import { doc, getDoc } from "firebase/firestore";
import getFormSession from "../../../Components/CluppForms/getFormSession";
import saveNotAnswersLanding from "../../../Components/CluppForms/saveNotAnswersLanding";
import { db } from "../../../firebase";
import ReferedProgram from "./ReferedProgram";

const landingId = "CF_REFERED_PROGRAM";

const onLoad = async ({ session, landedAt, uid }) => {
  try {
    const prevAnswers = {};
    const prevForm = await getFormSession(
      "cancelation-form",
      session.sessionID
    );
    const landings = prevForm.items;
    landings.forEach((item) => {
      if (item.answers.length > 0) {
        const lastField = item?.answers[0];
        const fieldID = lastField.field.id;
        const lastFieldType = lastField.type;
        const lastFieldAnswers = lastField[lastFieldType]?.value;
        prevAnswers[fieldID] = lastFieldAnswers;
      }
    });
    const userRef = doc(db, `users/${uid}`);
    const userSnap = await getDoc(userRef);
    const userData = userSnap.data();

    const referURL = `https://auto-clupp.web.app/ref.html?uid=${uid}`;

    return {
      userId: uid,
      ...prevAnswers,
      landedAt,
      prevForm,
      referURL,
      currentLanding: landingId,
      email: userData.email,
    };
  } catch (err) {
    console.log("Error:", err);
  }
};

const onSubmit = async ({
  state,
  session,
  fieldsStructure,
  nextPage,
  navigate,
}) => {
  if (session?.sessionID) {
    try {
      await saveNotAnswersLanding({
        landingId,
        state,
        sessionID: session.sessionID,
        prevForm: state.prevForm,
      });
      if (nextPage) navigate(await nextPage(state));
    } catch (err) {
      console.error("Error writing document to Firestore: ", err);
    }
  }
};

const content = ({ state, setState }) => (
  <ReferedProgram state={state} setState={setState} />
);

const nextPage = async (props) =>
  `/formulario/cancelacion/mejoras?uid=${props.uid}`;
const prevPage = (props) =>
  `/formulario/cancelacion/describe-clupp?uid=${props.uid}`;

const fieldsStructure = [];

const referedProgramProps = {
  landingId,
  onLoad,
  onSubmit,
  content,
  nextPage,
  prevPage,
  fieldsStructure,
};

export default referedProgramProps;
